import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ar from './locales/ar.json'
import nl from './locales/nl.json'

// Determine user's preferred language
function getDefaultLocale() {
  const savedLocale = localStorage.getItem('preferredLanguage')
  if (savedLocale) {
    return savedLocale
  }
  
  // Try to detect from browser
  const browserLang = navigator.language.split('-')[0]
  if (['en', 'ar', 'nl'].includes(browserLang)) {
    return browserLang
  }
  
  return 'en'; // Default fallback
}

export const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: getDefaultLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    ar,
    nl
  },
  // Add RTL support for Arabic
  runtimeOnly: false
})

// Update document direction based on language
export function updateDocumentDirection(locale: string) {
  document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr'
  document.documentElement.lang = locale
}

// Call this initially
updateDocumentDirection(getDefaultLocale())

export default i18n